<div [formGroup]="orderForm">

  <button mat-raised-button  color="primary"  (click)="addParameter()">Criar um novo parametro</button>



  <div formArrayName="items" *ngFor="let item of _items.controls; let i = index;">
    <div [formGroupName]="i">

      <mat-card>
        <mat-form-field>
          <input matInput formControlName="description" placeholder="Nome do Parametro">
        </mat-form-field>
  
        <button mat-icon-button color="primary" (click)="remove(i)" aria-label="Remover">
          <mat-icon>remove_circle</mat-icon>
        </button>

        <mat-form-field>
          <textarea matInput formControlName="textOptions" placeholder="Opções"></textarea>
        </mat-form-field>
<!-- 
      
        <lottery-param-options formControlName="options"></lottery-param-options> -->

      </mat-card>
      <br>
    </div>

  </div>


</div>